console.log("The Room 2.0");

const showRoomModal = (text, subtext, buttonText, url) => {
  const roomModal = document.querySelector("#room-modal");
  const roomModalText = document.querySelector("#room-modal-text");
  const roomModalSubtext = document.querySelector("#room-modal-subtext");
  const roomModalButton = document.querySelector("#room-modal-button");

  roomModalText.innerHTML = text;
  roomModalSubtext.innerHTML = subtext;
  roomModalButton.innerHTML = buttonText;
  roomModalButton.attributes["href"].value = url;

  roomModal.classList.add("show");
};

const showBecomeRoomieModal = () => {
  const roomModal = document.querySelector("#become-a-roomie");
  if (roomModal) {
    roomModal.classList.add("show");
  }
};

const hideBecomeRoomieModal = () => {
  const roomModal = document.querySelector("#become-a-roomie");
  if (roomModal) {
    sessionStorage.setItem("roomie-logged-in", "true");
    roomModal.classList.remove("show");
  }
};

const roomOriginalTitle = document.title;
const roomPsssTitle = "Psss... come back";
let psssInterval;
window.onblur = function () {
  document.title = roomPsssTitle;
  psssInterval = setInterval(() => {
    if (document.title === roomOriginalTitle) {
      document.title = roomPsssTitle;
    } else {
      document.title = roomOriginalTitle;
    }
  }, 4000);
};

window.onfocus = function () {
  clearInterval(psssInterval);
  document.title = roomOriginalTitle;
};

const fadeIns = document.querySelectorAll(".fadeIn");

for (let index = 0; index < fadeIns.length; index++) {
  const fadeIn = fadeIns[index];
  setTimeout(() => {
    fadeIn.classList.add("show");
  }, index * 400);
}

const fillUpMyWishlist = (wishes) => {
  console.log(wishes);
  const previousNotifications =
    localStorage.getItem("notifiedWishes")?.split(",") || [];

  const wishlist = document.querySelector("#my-wishlist");
  wishlist.innerHTML = "";
  if (wishlist && wishes && wishes.items && wishes.items.length) {
    wishes.items.forEach((wish) => {
      const chosenVariant = wish.variantId || wish.variantIds.split(",")[0];
      let soldout = false;
      const wishSelect = ` <select name="variant" class="select select-variant-wish">
                    ${wish.variantIds.split(",").map((variant, index) => {
                      const isAvailabel = wishes.available.data.nodes.find(
                        (x) => x.id == "gid://shopify/ProductVariant/" + variant
                      )?.availableForSale;

                      const numberAvailable = wishes.available.data.nodes.find(
                        (x) => x.id == "gid://shopify/ProductVariant/" + variant
                      )?.inventoryQuantity;
                      if (wish.variantId == variant && !isAvailabel) {
                        soldout = true;
                      }
                      if (!wish.variantId && !isAvailabel && index == 0) {
                        soldout = true;
                      }
                      return `<option value="${variant}" ${
                        wish.variantId == variant && 'selected="selected"'
                      }>${wish.variantTitles.split(",")[index]} ${
                        isAvailabel ? "" : " - Sold out"
                      }  ${
                        numberAvailable < 10 && numberAvailable > 0
                          ? " - Last few items"
                          : ""
                      }</option>`;
                    })}
                </select>`;

      const wishItem = document.createElement("li");
      wishItem.classList.add("wish-item");
      if (wish.variantIds && wish.variantIds.length) {
      }
      wishItem.innerHTML = `
               <a href="${wish.link}"  target="_blank"><img src="${
        wish.image
      }" alt="${wish.title}" /></a>
                <div class="flex-title">
                 <h3 class="h5"><a href="${wish.link}" target="_blank">${
        wish.title
      }</a></h3>
                <button data-id="${wish.id}">  <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      class="fullHeart"
      fill="currentColor"
    >
      <path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z"/>
    </svg></button>
                </div>
                
                <p class="price">${wish.price} EUR</p>

               ${wishSelect}

               
                <button data-id="${
                  wish.variantIds
                }" class="add-to-cart button button--full-width" ${
        soldout && previousNotifications.includes(chosenVariant) && "disabled"
      }>${
        soldout
          ? previousNotifications.includes(chosenVariant)
            ? "You will be notified"
            : "Notify me"
          : "Add to cart"
      }</button>


            `;
      wishlist.appendChild(wishItem);
    });

    const selectVariants = document.querySelectorAll(".select-variant-wish");

    selectVariants.forEach((sv) => {
      sv.addEventListener("change", () => {
        const previousNotifications =
          localStorage.getItem("notifiedWishes")?.split(",") || [];

        const selectedVariant = sv.options[sv.selectedIndex];
        const isSoldOut = selectedVariant.innerHTML.includes("Sold out");

        // check if saved
        if (previousNotifications.includes(selectedVariant.value)) {
          sv.nextElementSibling.innerHTML = "You will be notified";
          sv.nextElementSibling.disabled = true;
        } else {
          sv.nextElementSibling.disabled = false;
          sv.nextElementSibling.innerHTML = isSoldOut
            ? "Notify me when available"
            : "Add to cart";
        }
      });
    });
    // const addToCartButtons = document.querySelectorAll(".add-to-cart");

    // addToCartButtons.forEach((button) => {
    //   button.addEventListener("click", async (e) => {
    //     const articleId = e.target.dataset.id;
    //     const variant = e.target.parentElement.querySelector("select");
    //     const variantId = variant ? variant.value : articleId;

    //     const response = await fetch("/cart/add.js", {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //       body: JSON.stringify({
    //         items: [
    //           {
    //             id: variantId,
    //             quantity: 1,
    //           },
    //         ],
    //       }),
    //     });

    //     const data = await response.json();
    //     console.log(data);
    //     if (response.status == 200) {
    //       const cartCounter = document.querySelector(".cart-counter");
    //       cartCounter.innerHTML = parseInt(cartCounter.innerHTML) + 1;
    //     }

    //   });
    // });
  }
};

document.addEventListener("DOMContentLoaded", () => {
  // TODO TMAC: check if this is new roomie
  if (localStorage.getItem("roomie-logged-in") != "true") {
    if (sessionStorage.getItem("roomie-logged-in") != "true") {
      setTimeout(() => {
        if(window.shopifyTemplate.includes("bruna")){
          return;
        }

         if(window.shopifyTemplate.includes("summersale")){
          return;
        }
        showBecomeRoomieModal();
      }, 5000);
    }
  }
  // get links going to #become-roomie
  const becomeRoomieLinks = document.querySelectorAll(
    'a[href="#become-roomie"]'
  );
  becomeRoomieLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      showWishModal(
        "Enter your credentials to login",
        "Sign-in to get your discount.",
        "Become a Roomie now and get your discount!"
      );
    });
  });

  // get links to #valentine-discount
  const valentineDiscountLinks = document.querySelectorAll(
    'a[href="#valentine-discount"]'
  );

  valentineDiscountLinks.forEach((link) => {
    link.href = `https://theroomantwerp.com/discount/HAPPYVALENTINE?redirect=${window.location.pathname}`;
  });

  // get all prrreview-button buttons and add eventlisteners

  const previewButtons = document.querySelectorAll(".prrreview-button");
  previewButtons.forEach((button) => {
    button.addEventListener("click", (e) => {
      console.log("cliikiiee previewubbutton");
      e.stopImmediatePropagation();
      e.preventDefault();
      const loopIndex = e.target.dataset.loopindex;
      const bigimages = document.querySelector(".bigimages");
      const activeImage = bigimages.querySelector(".active");
      if (activeImage) {
        activeImage.classList.remove("active");
      }

      const zoomedImage = bigimages.querySelector(".zoomed");
      if (zoomedImage) {
        zoomedImage.classList.remove("zoomed");
      }
      const activepreview = document.querySelector(".activepreview");
      if (activepreview) {
        activepreview.classList.remove("activepreview");
      }

      e.target.classList.add("activepreview");
      bigImagesImages = bigimages.querySelectorAll(".roomie-zoom-image");
      bigImagesImages[loopIndex].classList.add("active");
    });
  });

  const leftbuttton = document.querySelector("#leftbuttton");
  const rightbuttton = document.querySelector("#rightbuttton");

  if (leftbuttton) {
    leftbuttton.addEventListener("click", () => {
      console.log("cldikkei LEFTT bittn");
      const activepreview = document.querySelector(".activepreview");
      const loopIndex = activepreview.dataset.loopindex;
      const nextIndex = parseInt(loopIndex) - 1;
      if (nextIndex >= 0) {
        const bigimages = document.querySelector(".bigimages");
        const activeImage = bigimages.querySelector(".active");
        if (activeImage) {
          activeImage.classList.remove("active");
        }
        const activepreview = document.querySelector(".activepreview");
        if (activepreview) {
          activepreview.classList.remove("activepreview");
        }
        const zoomedImage = bigimages.querySelector(".zoomed");
        if (zoomedImage) {
          zoomedImage.classList.remove("zoomed");
        }
        const previewButtons = document.querySelectorAll(".prrreview-button");
        previewButtons[nextIndex].classList.add("activepreview");
        previewButtons[nextIndex].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
        bigImagesImages = bigimages.querySelectorAll(".roomie-zoom-image");
        bigImagesImages[nextIndex].classList.add("active");
      }
    });
  }

  if (rightbuttton) {
    rightbuttton.addEventListener("click", () => {
      console.log("clidkkiee RIGHT");
      const activepreview = document.querySelector(".activepreview");
      const loopIndex = activepreview.dataset.loopindex;
      const nextIndex = parseInt(loopIndex) + 1;
      const previewButtons = document.querySelectorAll(".prrreview-button");
      if (nextIndex < previewButtons.length) {
        const bigimages = document.querySelector(".bigimages");
        const activeImage = bigimages.querySelector(".active");
        const zoomedImage = bigimages.querySelector(".zoomed");
        if (zoomedImage) {
          zoomedImage.classList.remove("zoomed");
        }
        if (activeImage) {
          activeImage.classList.remove("active");
        }
        const activepreview = document.querySelector(".activepreview");
        if (activepreview) {
          activepreview.classList.remove("activepreview");
          activepreview.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center",
          });
        }
        previewButtons[nextIndex].classList.add("activepreview");
        bigImagesImages = bigimages.querySelectorAll(".roomie-zoom-image");
        bigImagesImages[nextIndex].classList.add("active");
      }
    });
  }

  document.querySelectorAll(".roomie-zoom-image").forEach((image, index) => {
    image.addEventListener("click", () => {
      if (image.nodeName.toLowerCase() != "img") {
        return;
      }
      // zoom in image on first click, set a class so we can change the cursor
      // zoom the image in on the place where the user clicked
      // make sure the image does not go out of the screen
      // zoom the image out on the second click

      if (image.classList.contains("zoomed")) {
        image.classList.remove("zoomed");
        image.style.scale = 1;
      } else {
        image.classList.add("zoomed");
        image.style.scale = 2;

        image.style.transformOrigin = `${event.offsetX}px ${event.offsetY}px`;
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", async () => {
  const shopTheLookBars = document.querySelectorAll(".shop-the-look-bar");
  if (shopTheLookBars.length > 1) {
    const ogShop = shopTheLookBars[0];

    for (let index = 1; index < shopTheLookBars.length; index++) {
      const element = shopTheLookBars[index];
      const elementsInside = element.querySelectorAll(
        ".shop-the-look-bar__item"
      );
      //loop over and inject in ogShop
      elementsInside.forEach((el) => {
        const clone = el.cloneNode(true);
        ogShop.appendChild(clone);
      });
      //remove the element
      element.remove();
    }
  }
  const modalButton = document.getElementById("room-modal-button");
  if (modalButton) {
    modalButton.addEventListener("click", (e) => {
      // if href is # remove the show class from the modal
      if (modalButton.attributes["href"].value == "#") {
        e.preventDefault();
        const roomModal = document.querySelector("#room-modal");
        roomModal.classList.remove("show");
      }
    });
  }

  const modalBackdrop = document.querySelector(".modal-backdrop");
  const modalBackdropModal = document.querySelector(".modal-backdrop .modal");
  if (modalBackdropModal) {
    modalBackdropModal.addEventListener("click", (e) => {
      e.stopImmediatePropagation();

      e.stopPropagation();
    });
  }
  if (modalBackdrop) {
    modalBackdrop.addEventListener("click", (e) => {
      // if href is # remove the show class from the modal
      const roomModal = document.querySelector("#room-modal");
      roomModal.classList.remove("show");
    });
  }

  const easterButtons = document.querySelectorAll(".easterButton");
  const hasFullBasket = document.querySelector(".easter-basket-full");

  if (hasFullBasket) {
    // get full img from data attribute
    const fullImg = hasFullBasket.dataset.src;
    // set src of img to full img
    hasFullBasket.src = fullImg;
  }
  easterButtons.forEach((button) => {
    button.addEventListener("click", async (e) => {
      try {
        e.preventDefault();

        const id = e.target.dataset.variantid;
        const roomie = e.target.dataset.roomie;
        const cartTotal = e.target.dataset.cart;
        const currency = e.target.dataset.currency;
        if (roomie !== "true") {
          showRoomModal(
            "You're almost there!<br>sign in to receive your free easter egg.",
            "Not a roomie yet?<br><a href='/account/register'>become a Roomie and join the easter egg hunt!</a>",
            "sign in",
            "/account/login?checkout_url=" +
              encodeURI(
                window.location.href.replace(window.location.origin, "")
              )
          );

          return;
        }

        if (parseInt(cartTotal) < 10000) {
          showRoomModal(
            `To add your free easter egg to your order, make sure your basket total is at least ${Shopify.currency.active
              .replace("EUR", "€")
              .replace("USD", "$")}${(Shopify.currency.rate * 100).toFixed(
              2
            )} <br><br>fill up your basket and the egg will be yours - automatically unlocked at checkout!`,
            "",
            "continue shopping",
            "#"
          );

          return;
        }

        e.target.classList.add("clicked");
        e.target.disabled = true;
        e.target.innerHTML = "Adding...";
        const addJson = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            items: [
              {
                id: id,
                quantity: 1,
              },
            ],
            sections: [
              "cart-notification-product",
              "cart-notification-button",
              "cart-icon-bubble",
            ],
          }),
        });
        if (addJson.status == 200) {
          e.target.innerHTML = "Added!";
          const data = await addJson.json();
          const cartIconBubble = document.querySelector("#cart-icon-bubble");
          cartIconBubble.innerHTML = data.sections["cart-icon-bubble"];

          const cartIconCart = document.querySelector(
            "#cart-notification-product"
          );
          cartIconCart.innerHTML = data.sections["cart-notification-product"];

          const cartIconButton = document.querySelector(
            "#cart-notification-button"
          );
          cartIconButton.innerHTML = data.sections["cart-notification-button"];

          const hasFullBasket = document.querySelector(".easter-basket-full");

          if (hasFullBasket) {
            // get full img from data attribute
            const fullImg = hasFullBasket.dataset.src;
            // set src of img to full img
            hasFullBasket.src = fullImg;
          }

          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.cart.open();
        }
      } catch (error) {
        console.log("reerrr", error);
      }
    });
  });
});
